import * as React from "react"
import type { SVGProps } from "react"
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.85 17.4 12 15.5l3.15 1.92-.82-3.6 2.77-2.4-3.65-.32L12 7.7l-1.45 3.37-3.65.33 2.78 2.42zm3.15.45-4.15 2.5a1 1 0 0 1-.57.15 1 1 0 0 1-.53-.2 1 1 0 0 1-.35-.44 1 1 0 0 1-.05-.59l1.1-4.72-3.68-3.18a1 1 0 0 1-.27-1.07 1 1 0 0 1 .3-.45q.2-.18.55-.23L9.2 9.2l1.88-4.45a1 1 0 0 1 .38-.45q.27-.15.54-.15t.54.15.39.45L14.8 9.2l4.85.42q.35.05.55.23.2.16.3.45a1 1 0 0 1-.28 1.07l-3.67 3.18 1.1 4.72a1 1 0 0 1-.05.59q-.12.26-.35.44a1 1 0 0 1-.52.2 1 1 0 0 1-.58-.15z" />
  </svg>
)
export default SvgStar
